require('lightbox2');
require('magnify');
